export * from './declaracao-de-autonomo-e-renda';
export * from './declaracao-de-domicilio';
export * from './declaracao-de-vizinhos';
export * from './morador-averbacao';
export * from './morador-usucampeao-reurb-averbacao';
export * from './morador-usucampeao_2021';
export * from './procuracao-averbacao';
export * from './procuracao-reurb-averbacao';
export * from './questionario-juridico';